// extracted by css-extract-rspack-plugin
export default {"root":"root-YsQFlq","date":"date-Q1U3iC","messages":"messages-mZMubz","chat":"chat-xquAQz","shrinkChat":"shrinkChat-lSSrhj","section":"section-Jwuy9U","prev":"prev-X0aqYR"};